import { Model } from 'modules/core/lib/mobx-rest'

interface ILegalGender {
  id: string
  gender_id: string
  legal_entity_id: string
}

class LegalGender extends Model<ILegalGender> {
  static urlRoot() {
    return '/legal_genders'
  }
}

export default LegalGender
